import React from "react";

const LOOK = {
  active: ["Active", "bg-emerald-500/15 text-emerald-200 border-emerald-400/30"],
  archived: ["Archived", "bg-white/10 text-nex-silver border-white/20"],
  none: ["No file", "bg-amber-500/15 text-amber-200 border-amber-400/30"],
};

export const statusOf = (map, x) => (x.resident_id ? map[x.resident_id] || "none" : "none");

/** Small status chip next to a resident name; tapping it applies that filter. */
export function StatusChip({ st, onPick, testid }) {
  const [label, cls] = LOOK[st];
  return (
    <span role="button" tabIndex={0} data-testid={testid} onClick={(e) => { e.stopPropagation(); onPick(st); }}
      onKeyDown={(e) => { if (e.key === "Enter") { e.stopPropagation(); onPick(st); } }}
      className={`shrink-0 px-1.5 py-0.5 rounded-sm border font-mono text-[9px] uppercase tracking-[0.12em] cursor-pointer hover:brightness-125 transition-[filter] ${cls}`}>{label}</span>
  );
}

/** On list / Active / Archived chips with distinct-resident counts. */
export function StatusStrip({ rows, map, value, onChange, shown }) {
  const ids = (st) => new Set(rows.filter((x) => x.resident_id && (!st || statusOf(map, x) === st)).map((x) => x.resident_id)).size;
  const opts = [["all", "On list", ids()], ["active", "Active", ids("active")], ["archived", "Archived", ids("archived")]];
  const noFile = rows.filter((x) => statusOf(map, x) === "none").length;
  if (noFile || value === "none") opts.push(["none", "No file", noFile]);
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="flow-status-strip">
      {opts.map(([k, l, n]) => (
        <button key={k} type="button" onClick={() => onChange(k)} data-testid={`flow-status-${k}`}
          className={`px-3 py-1.5 rounded-sm border font-mono text-[10px] uppercase tracking-[0.14em] transition-colors ${value === k ? "border-nex-gold text-nex-gold bg-nex-gold/10" : "border-white/10 text-nex-muted hover:text-nex-silver"}`}>
          {l} <span data-testid={`flow-status-${k}-count`} className="ml-1 tabular-nums">{n}</span>
        </button>))}
      {value !== "all" && <span className="text-[11px] text-nex-muted" data-testid="flow-status-showing">Showing {shown} of {rows.length} rows</span>}
    </div>
  );
}
